import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../utils/userProvider";
import axios from "axios";

export default function useDeleteUser() {
  const backend_url = process.env.REACT_APP_BACKEND_URL;
  const { authState, setAuthState } = useContext(AuthContext);
  let target = `${backend_url}/users`;

  //id, status, remarks
  const [data, setData] = useState();

  const [res, setRes] = useState({
    data: null,
    loading: false,
    error: false,
  });

  useEffect(() => {
    if (!data) return;
    setRes({
      data: null,
      loading: true,
      error: false,
    });
    axios({
      url: target + `/${data.id}`,
      method: "DELETE",
      data: data,
      headers: {
        Authorization: `Bearer ${authState.jwt ? authState.jwt : ""}`,
      },
    })
      .then((res) =>
        setRes({
          data: res.data,
          loading: false,
          error: false,
        })
      )
      .catch((e) => {
        setRes({
          data: null,
          loading: false,
          error: true,
          errorMessage: e,
        });
      });
  }, [data]);

  return [res, setData];
}
